module.exports = __webpack_public_path__ + "static/img/アセット 65-2@3x.60c698a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 65-2@3x.png
// module id = OoId
// module chunks = 1